"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderBySchema = exports.FeatureExpPaginationQueryParamSchema = exports.FeatureExpPaginationSchema = void 0;
const zod_1 = require("zod");
exports.FeatureExpPaginationSchema = zod_1.z.object({
    current_items_count: zod_1.z.number(),
    current_page: zod_1.z.number(),
    total_count: zod_1.z.number(),
    items_per_page: zod_1.z.number(),
    last_page: zod_1.z.number(),
});
exports.FeatureExpPaginationQueryParamSchema = zod_1.z.object({
    _page: zod_1.z.number().optional(),
    _max_per_page: zod_1.z.number().optional(),
});
exports.OrderBySchema = zod_1.z.enum(['ASC', 'DESC']);
//# sourceMappingURL=schemas.js.map